var React = require('react');

function TimelapsePlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 5v14l11-7z"}));
}

TimelapsePlay.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = TimelapsePlay;

TimelapsePlay.default = TimelapsePlay;
